import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/scss/bootstrapExtended.scss';
import './assets/scss/Global.scss';
import { store } from './api/store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

var iconScript = document.createElement('script');
iconScript.src = 'https://kit.fontawesome.com/870d417604.js';
iconScript.crossOrigin = 'anonymous';
document.head.appendChild(iconScript);
root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);
